document.addEventListener('DOMContentLoaded', () => {
  $('.addons-multiple-select').select2()
  const $root = $('.user-card')

  if (!$root.length) {
    return
  }

  const $changePassword = $root.find('.user-card__change-password-section')

  $root.on('click', '.user-card__change-password', () => {
    $changePassword.slideToggle(300)
  })

  $root.on('click', '.user-card__change-cancel', () => {
    $changePassword.slideToggle(300)
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const userCountryHost = $('.users__status.users__status--country')
  const dropdown = $('.users__status.users__status--country #country-dropdown')
  const userId = userCountryHost.data('user-id')
  if (userCountryHost && dropdown) {
    userCountryHost.off('click').on('click', () => {
      dropdown.toggle('hidden')
    })

    // Handle country selection
    dropdown.off('click').on('click', event => {
      const selectedItem = event.target.closest('.dropdown-item')
      if (!selectedItem) return

      const countryId = selectedItem.getAttribute('data-country-id')

      fetch(`/admin/users/${userId}/update_country_host.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ country_id: countryId }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error updating country')
          }
          return response.json()
        })
        .then(data => {
          $('#user__country').html(data?.name)
        })
        .catch(error => {
          console.error('Error:', error)
        })
    })
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const $chargesContainer = $('.user-billing__charges-container')

  if ($chargesContainer.length) {
    $.get($chargesContainer.data('url')).then(result => {
      $chargesContainer.html(result)
    })
  }
})

var userUpdateGeoCodeEventAdded = false
document.addEventListener('DOMContentLoaded', () => {
  // if follow code above it will fire events multiple times if other part of page is reloaded
  if (userUpdateGeoCodeEventAdded) return
  userUpdateGeoCodeEventAdded = true

  $(document).on('click', '.update-user-geo-code', e => {
    let userInput = prompt('Update user geo code')
    if (userInput != null && userInput !== '') {
      fetch(e.currentTarget.getAttribute('data-user-update-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: { geoip_code: userInput } }),
      })
        .then(response => {
          return response.json().then(data => {
            if (data.success) {
              e.currentTarget.innerText = '...'
              window.location.replace(window.location.toString())
            } else {
              alert("Can't update user geo code.\n" + data.message)
            }
          })
        })
        .catch(error => {
          alert("Can't update user geo code.\n" + error)
        })
    }
    return false
  })

  $(document).on('click', '.update-user-locale', e => {
    let availableLocales = e.currentTarget.getAttribute('data-available-locales')
    let userInput = prompt(`Update user locale, possible values: ${availableLocales}`)
    if (userInput != null && userInput !== '') {
      fetch(e.currentTarget.getAttribute('data-user-update-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: { locale: userInput } }),
      })
        .then(response => {
          return response.json().then(data => {
            if (data.success) {
              e.currentTarget.innerText = '...'
              window.location.replace(window.location.toString())
            } else {
              alert("Can't update user locale.\n" + data.message)
            }
          })
        })
        .catch(error => {
          alert("Can't update user locale.\n" + error)
        })
    }
    return false
  })
})
